import { application } from "./application"

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import AutoGrowController from "./auto_grow_controller"
application.register("auto-grow", AutoGrowController)

import FormatFieldsController from "./format_fields_controller"
application.register("format-fields", FormatFieldsController)

import ColumnFilterController from "./column_filter_controller"
application.register("column-filter", ColumnFilterController)

import ClearableController from "./clearable_controller"
application.register("clearable", ClearableController)

import ColumnsController from "./columns_controller"
application.register("columns", ColumnsController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import ReturnOriginController from "./return_origin_controller"
application.register("return-origin", ReturnOriginController)

import BackLinkController from "./back_link_controller"
application.register("back-link", BackLinkController)

import ScrollMemoryController from "./scroll_memory_controller"
application.register("scroll-memory", ScrollMemoryController)

import PreserveScrollController from "./preserve_scroll_controller"
application.register("preserve-scroll", PreserveScrollController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import ContextMenuController from "./context_menu_controller"
application.register("context-menu", ContextMenuController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PreviewRefreshController from "./preview_refresh_controller"
application.register("preview-refresh", PreviewRefreshController)

import PreviewDeclinesController from "./preview_declines_controller"
application.register("preview-declines", PreviewDeclinesController)

import PreviewBlockFocusController from "./preview_block_focus_controller"
application.register("preview-block-focus", PreviewBlockFocusController)

import TraceSourcesController from "./trace_sources_controller"
application.register("trace-sources", TraceSourcesController)

import PendingRowsController from "./pending_rows_controller"
application.register("pending-rows", PendingRowsController)

import IterationSummaryController from "./iteration_summary_controller"
application.register("iteration-summary", IterationSummaryController)

import ImportColumnsController from "./import_columns_controller"
application.register("import-columns", ImportColumnsController)

import FieldPathOverridesController from "./field_path_overrides_controller"
application.register("field-path-overrides", FieldPathOverridesController)

import ColumnValidationsController from "./column_validations_controller"
application.register("column-validations", ColumnValidationsController)

import ColumnFormatController from "./column_format_controller"
application.register("column-format", ColumnFormatController)


import ColumnTypesController from "./column_types_controller"
application.register("column-types", ColumnTypesController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import MappingRowController from "./mapping_row_controller"
application.register("mapping-row", MappingRowController)

import ConditionsEditorController from "./conditions_editor_controller"
application.register("conditions-editor", ConditionsEditorController)

import ConcatPartController from "./concat_part_controller"
application.register("concat-part", ConcatPartController)

import ValueKindController from "./value_kind_controller"
application.register("value-kind", ValueKindController)

import CondBranchController from "./cond_branch_controller"
application.register("cond-branch", CondBranchController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DisclosureLinkController from "./disclosure_link_controller"
application.register("disclosure-link", DisclosureLinkController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import SubmitLoadingController from "./submit_loading_controller"
application.register("submit-loading", SubmitLoadingController)

import FrameBusyController from "./frame_busy_controller"
application.register("frame-busy", FrameBusyController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RevealRowsController from "./reveal_rows_controller"
application.register("reveal-rows", RevealRowsController)

import TimecardSplitController from "./timecard_split_controller"
application.register("timecard-split", TimecardSplitController)

import TimecardReferenceReplacementController from "./timecard_reference_replacement_controller"
application.register("timecard-reference-replacement", TimecardReferenceReplacementController)

import ActionConfirmController from "./action_confirm_controller"
application.register("action-confirm", ActionConfirmController)

import SnoozeMenuController from "./snooze_menu_controller"
application.register("snooze-menu", SnoozeMenuController)

import ChannelFieldsController from "./channel_fields_controller"
application.register("channel-fields", ChannelFieldsController)

import DirtyGuardController from "./dirty_guard_controller"
application.register("dirty-guard", DirtyGuardController)

import UploadFormController from "./upload_form_controller"
application.register("upload-form", UploadFormController)

import TokenSelectController from "./token_select_controller"
application.register("token-select", TokenSelectController)

import CustomerMatchController from "./customer_match_controller"
application.register("customer-match", CustomerMatchController)

import TurboConfirmController from "./turbo_confirm_controller"
application.register("turbo-confirm", TurboConfirmController)
import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import EmailTemplatePreviewController from "./email_template_preview_controller"
application.register("email-template-preview", EmailTemplatePreviewController)

import EmailTemplateVariablesController from "./email_template_variables_controller"
application.register("email-template-variables", EmailTemplateVariablesController)

import RejectReasonController from "./reject_reason_controller"
application.register("reject-reason", RejectReasonController)

import SampleFileController from "./sample_file_controller"
application.register("sample-file", SampleFileController)

import RememberUsernameController from "./remember_username_controller"
application.register("remember-username", RememberUsernameController)

import ImportButtonController from "./import_button_controller"
application.register("import-button", ImportButtonController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import FlyoutMenuController from "./flyout_menu_controller"
application.register("flyout-menu", FlyoutMenuController)

import ValueTextController from "./value_text_controller"
application.register("value-text", ValueTextController)

import UniqueOptionsController from "./unique_options_controller"
application.register("unique-options", UniqueOptionsController)


export { application }

import CableReconnectController from "./cable_reconnect_controller"
application.register("cable-reconnect", CableReconnectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import TimecardKeysController from "./timecard_keys_controller"
application.register("timecard-keys", TimecardKeysController)

import TimecardJumpController from "./timecard_jump_controller"
application.register("timecard-jump", TimecardJumpController)

import ColumnReorderController from "./column_reorder_controller"
application.register("column-reorder", ColumnReorderController)
